import { useEffect, useRef, useContext, useState, useMemo, memo } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import BtnLoader from '../BtnLoader';
import ImageLoad from '../ImageLoad';
import { socket } from '../../socket';
import Payment from '../Payment/Payment';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import PickupPin from "../../assets/Image/pickup.png";
import DropPin from "../../assets/Image/drop.png";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UpcomingModel = ({ data, setShowModel, handleData, handleGetDriverDetail }) => {

    const { t } = useTranslation();
    const { BaseUrl, handleCallApi, setShowToast, setToastMsg } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [acceptData, setAcceptData] = useState(null);
    const [pickupData, setPickupData] = useState(null);
    const [dropData, setDropData] = useState(null);
    const [allLocation, setAllLoation] = useState([]);
    const [driverLocation, setDriveLocation] = useState(null);
    const [isPayment, setIsPayment] = useState(false);
    const [paymentData, setPaymentData] = useState("");
    const [paymentList, setPaymentList] = useState("");
    const [selectPayment, setSelectPayment] = useState("");
    const [time, setTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const [timeType, setTimeType] = useState("Dec");
    const [stopList, setStopList] = useState([]);
    const [completeData, setCompleteData] = useState("");
    const [bankData, setBankData] = useState(null);
    const [showSosModal, setShowSosModal] = useState(false);
    const [emergencyContacts, setEmergencyContacts] = useState([]);
    const [emergencyContactNumber, setEmergencyContactNumber] = useState("112");

    const [additionalDetail, setAdditionalDetail] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);

    useEffect(() => {
        if (data && data.m_role && String(data.m_role) !== "1") {
            const uid = secureLocalStorage.getItem("Userid");
            setDetailLoading(true);
            handleCallApi("Post", "customer/ride_additional_detail", {
                uid: uid,
                request_id: data.id,
                status: "1"
            }).then((res) => {
                setDetailLoading(false);
                if (res.data && res.data.Result === true) {
                    setAdditionalDetail(res.data.add_data);
                }
            }).catch(err => {
                setDetailLoading(false);
                console.error("Error fetching additional details:", err);
            });
        }
    }, [data, handleCallApi]);

    useEffect(() => {
        const uid = secureLocalStorage.getItem("Userid");
        if (uid) {
            handleCallApi("Get", `safety/customer/emergency_contacts?user_id=${uid}`).then((res) => {
                if (res.data && res.data.Result === true) {
                    setEmergencyContacts(res.data.contacts || []);
                }
            }).catch(err => console.error("Error loading emergency contacts in model:", err));
        }
        handleCallApi("Get", "safety/emergency_settings").then((res) => {
            if (res.data && res.data.Result === true) {
                setEmergencyContactNumber(res.data.emergency_contact_number || "112");
            }
        }).catch(err => console.error("Error loading emergency settings in model:", err));
    }, [data, handleCallApi]);

    const confirmSosTrigger = () => {
        const uid = secureLocalStorage.getItem("Userid");
        
        const triggerApi = (lat, lon) => {
            const body = {
                ride_id: data?.id,
                reporter_type: "customer",
                reporter_id: uid,
                latitude: lat.toString(),
                longitude: lon.toString()
            };
            handleCallApi("Post", "safety/sos_trigger", body).then((res) => {
                if (res.data.Result === true) {
                    setToastMsg(t("🚨 SOS Emergency Signal sent to support center successfully!"));
                    setShowToast(true);
                } else {
                    setToastMsg(res.data.message || t("Failed to trigger SOS"));
                    setShowToast(true);
                }
            }).catch((err) => {
                setToastMsg(t("Network connection error"));
                setShowToast(true);
            });
        };

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    triggerApi(position.coords.latitude, position.coords.longitude);
                },
                () => {
                    triggerApi(0.0, 0.0);
                }
            );
        } else {
            triggerApi(0.0, 0.0);
        }
        setShowSosModal(false);
    };

    const intervalRef = useRef(null);
    const FetchRef = useRef(false);
    const TimeRef = useRef(false);
    const statusRef = useRef(null);

    const navigate = useNavigate();

    const currency = secureLocalStorage.getItem("currency");

    const routeStops = useMemo(() => {
        const pickupStop = { type: "pickup", title: data?.pickup?.title || "", subtitle: data?.pickup?.subtitle || "", colorClass: "location-icon-green", textClass: "text-green-600", label: t("PICKUP") };
        const stops = data?.drop_list || [];
        
        if (stops.length >= 1) {
            const intermediateStops = [
                data?.drop,
                ...stops.slice(0, -1)
            ].map((stop, idx) => ({
                type: "stop",
                title: stop?.title || "",
                subtitle: stop?.subtitle || "",
                colorClass: "location-icon-yellow",
                textClass: "text-yellow-600",
                label: `${t("STOP")} ${idx + 1}`
            }));
            const finalStop = stops[stops.length - 1];
            const finalDestination = {
                type: "drop",
                title: finalStop?.title || "",
                subtitle: finalStop?.subtitle || "",
                colorClass: "location-icon-red",
                textClass: "text-red-600",
                label: t("DESTINATION")
            };
            return [pickupStop, ...intermediateStops, finalDestination];
        } else {
            const finalDestination = {
                type: "drop",
                title: data?.drop?.title || "",
                subtitle: data?.drop?.subtitle || "",
                colorClass: "location-icon-red",
                textClass: "text-red-600",
                label: t("DESTINATION")
            };
            return [pickupStop, finalDestination];
        }
    }, [data, t]);

    useEffect(() => {
        if (FetchRef.current) return;
        FetchRef.current = true;

        const uid = secureLocalStorage.getItem("Userid");

        if (data) {
            const { id, pickup, drop, drop_list, d_id, map_img, latitude, longitude, status } = data;

            setCompleteData({
                uid, d_id,
                request_id: id,
                wallet: 0
            });

            if (status === "7") {
                setIsPayment(true);
                setPaymentData(data);
                hadnleGetPaymentList();
                return;
            }

            setPickupData({
                title: pickup?.title,
                subtitle: pickup?.subtitle,
                lat: Number(pickup?.latitude),
                lng: Number(pickup?.longitude)
            });

            const stops = drop_list || [];
            if (stops.length >= 1) {
                const finalStop = stops[stops.length - 1];
                setDropData({
                    title: finalStop?.title,
                    subtitle: finalStop?.subtitle,
                    lat: Number(finalStop?.latitude),
                    lng: Number(finalStop?.longitude)
                });
                const intermediateStops = [
                    drop,
                    ...stops.slice(0, -1)
                ];
                setStopList(intermediateStops.map((item) => ({ lat: Number(item.latitude), lng: Number(item.longitude) })));
            } else {
                setDropData({
                    title: drop?.title,
                    subtitle: drop?.subtitle,
                    lat: Number(drop?.latitude),
                    lng: Number(drop?.longitude)
                });
                setStopList([]);
            }

            setDriveLocation({
                image: BaseUrl + map_img,
                lat: Number(latitude),
                lng: Number(longitude)
            });
        }
        handleFetchData();
        hadnleGetPaymentList();
    }, []);

    useEffect(() => {
        statusRef.current = acceptData?.status;
    }, [acceptData]);

    useEffect(() => {
        if (acceptData) {
            const totalSeconds =
                (Number(acceptData.tot_hour) || 0) * 3600 +
                (Number(acceptData.tot_minute) || 0) * 60 +
                (Number(acceptData.tot_second) || 0);

            setTime(totalSeconds);

            if (
                acceptData.status === "1" ||
                acceptData.status === "2" ||
                acceptData.status === "5" ||
                acceptData.status === "6"
            ) {
                if (acceptData.timer_status === 1) {
                    setTimeType("Dec");
                } else {
                    setTimeType("Inc");
                }
                setIsRunning(true);
            } else {
                setIsRunning(false);
            }
            return;
        }

        if (TimeRef.current) return;
        if (
            data?.run_time?.second !== 0 ||
            data?.run_time?.minute !== 0 ||
            data?.run_time?.hour !== 0
        ) {
            const TotalSecond =
                data?.run_time.hour * 3600 +
                data?.run_time.minute * 60 +
                data?.run_time.second;
            setIsRunning(true);
            if (TotalSecond > 0) {
                setTimeType("Dec");
                setTime(TotalSecond);
            } else {
                setTimeType("Inc");
                setTime(Math.abs(TotalSecond));
                TimeRef.current = true;
            }
        }
    }, [acceptData]);

    useEffect(() => {
        if (data?.status === "7") return;
        const saved = secureLocalStorage.getItem("timerData");
        if (!saved) return;
        const { startTime, duration } = JSON.parse(saved);
        const now = Date.now();
        const diff = Math.floor((now - startTime) / 1000);
        const remaining = duration - diff;
        TimeRef.current = true;
        setIsRunning(true);
        if (remaining > 0) {
            setTimeType("Dec");
            setTime(remaining);
        } else {
            setTimeType("Inc");
            setTime(Math.abs(remaining));
        }
    }, []);

    useEffect(() => {
        if (!isRunning) return;
        intervalRef.current = setInterval(() => {
            setTime(prev => {
                if (timeType === "Dec") {
                    if (prev <= 0) {
                        if (statusRef.current === "2" || statusRef.current === "5" || statusRef.current === "6") {
                            setTimeType("Inc");
                            return 0;
                        } else {
                            clearInterval(intervalRef.current);
                            setIsRunning(false);
                            secureLocalStorage.removeItem("timerData");
                            return 0;
                        }
                    }
                    return prev - 1;
                }
                return prev + 1;
            });

        }, 1000);
        return () => clearInterval(intervalRef.current);
    }, [isRunning, timeType]);

    useEffect(() => {
        if (time === 0 && isRunning && timeType === "Dec") {
            const currentStatus = String(acceptData?.status || data?.status);
            if (currentStatus === "1") {
                const uid = secureLocalStorage.getItem("Userid");
                socket.emit("Vehicle_Time_Request", {
                    uid,
                    d_id: data?.d_id
                });
            }
        }
    }, [time, isRunning, timeType, acceptData, data]);

    useEffect(() => {

        const uid = secureLocalStorage.getItem("Userid");

        const handleReconnect = () => {
            console.log("Socket reconnected in UpcomingModel, refreshing ride state...");
            handleFetchData();
        };

        socket.on("connect", handleReconnect);
        socket.on(`V_Driver_Location${uid}`, hadnleVDriverLocation);
        socket.on("Vehicle_D_IAmHere", handleVehicleDIAmHere);
        socket.on(`Vehicle_Accept_Cancel${uid}`, hadnleVehicleAcceptCancel);
        socket.on(`Vehicle_Ride_Payment${uid}`, handleVehicleRidePayment);
        socket.on("Vehicle_Ride_OTP", handleVehicleRideOTP);
        socket.on(`Vehicle_Ride_Start_End${uid}`, handleVehicleRideStartEnd);
        socket.on(`Vehicle_Time_update${uid}`, handleVehicleTimeupdate);

        return () => {
            socket.off("connect", handleReconnect);
            socket.off(`V_Driver_Location${uid}`, hadnleVDriverLocation);
            socket.off("Vehicle_D_IAmHere", handleVehicleDIAmHere);
            socket.off(`Vehicle_Accept_Cancel${uid}`, hadnleVehicleAcceptCancel);
            socket.off(`Vehicle_Ride_Payment${uid}`, handleVehicleRidePayment);
            socket.off("Vehicle_Ride_OTP", handleVehicleRideOTP);
            socket.off(`Vehicle_Ride_Start_End${uid}`, handleVehicleRideStartEnd);
            socket.off(`Vehicle_Time_update${uid}`, handleVehicleTimeupdate);
        };

    }, []);

    const startPersistentTimer = (seconds) => {
        const startTime = Date.now();

        secureLocalStorage.setItem("timerData", JSON.stringify({
            startTime,
            duration: seconds
        }));

        TimeRef.current = true;
        setIsRunning(true);
        setTimeType("Dec");
        setTime(seconds);
    };

    const hadnleGetPaymentList = async () => {
        const Response = await handleCallApi("Get", "customer/coupon_payment");
        const PaymentList = Response.data.payment_list;
        setPaymentList(PaymentList);
        const FindPayment = PaymentList.find((item) => item.name === data?.p_name);
        setSelectPayment(FindPayment);
        setBankData(Response.data?.bank_data);
        setLoading(false);
    }

    const hadnleVDriverLocation = (data) => {
        if (data) {
            setDriveLocation({
                image: BaseUrl + data?.driver_location.image,
                lat: Number(data?.driver_location.latitude),
                lng: Number(data?.driver_location.longitude)
            });

        }
    };

    const hadnleVehicleAcceptCancel = (data) => {
        setShowModel("");
        if (handleData) {
            handleData();
        }
    };

    const handleVehicleRidePayment = (data) => {
        if (data) {
            setIsPayment(true);
            setPaymentData({ ...data.price_list, ...data?.payment_data });
            secureLocalStorage.removeItem("timerData");
            TimeRef.current = true;
            clearInterval(intervalRef.current);
        }
    };

    const handleVehicleRideOTP = (data) => {
        if (data) {
            secureLocalStorage.removeItem("timerData");
            TimeRef.current = true;
            clearInterval(intervalRef.current);
            setIsRunning(false);
            handleFetchData();
        }
    };

    const handleVehicleDIAmHere = (data) => {
        if (data) {
            startPersistentTimer(data?.pickuptime * 60);
            handleFetchData();
        }
    };

    const handleVehicleRideStartEnd = (data) => {
        if (data) {
            startPersistentTimer(data?.tot_min * 60);
            handleFetchData();
        }
    };

    const handleVehicleTimeupdate = (data) => {
        if (data) {
            startPersistentTimer(Number(data.time) * 60);
            handleFetchData();
        }
    };

    const handleFetchData = async () => {

        const uid = secureLocalStorage.getItem("Userid");

        const Response = await handleCallApi(
            "Post",
            "customer/vehicle_driver_detail",
            {
                uid,
                d_id: data?.d_id,
                request_id: data?.id
            }
        );

        const accepted = Response.data.accepted_d_detail;
        if (accepted && (!Array.isArray(accepted) || accepted.length > 0)) {
            setAcceptData(accepted);
        } else {
            setAcceptData(null);
        }

        setLoading(false);

    };

    const formatTime = (seconds) => {

        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;

    };

    const handleCloseModel = () => {
        setShowModel("");
        if (data.status !== acceptData?.status) {
            handleData();
        }
    }

    if (loading) {
        return (
            <div className="h-[calc(100vh-40px)]">
                <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
            </div>
        );
    }

    return (
        <div>

            {!isPayment && <div className="flex flex-col max-h-[85vh]">
                <div className="px-4 py-2 flex items-center justify-between border-b border-gray-100 flex-shrink-0">
                    <div className="flex items-center gap-3">
                        <h1 className="font-semibold">{t("Booking id")} : #{data?.id}</h1>
                        {(acceptData?.status === "1" || acceptData?.status === "2" || acceptData?.status === "5") && (
                            <button onClick={() => setShowSosModal(true)} className="bg-red-600 hover:bg-red-700 text-white font-bold px-3 py-1 rounded-lg flex items-center gap-1.5 text-xs transition-all duration-300 shadow-md animate-pulse">
                                🔴 {t("SOS")}
                            </button>
                        )}
                    </div>
                    <button onClick={handleCloseModel}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                        </svg>
                    </button>
                </div>

                <div className="overflow-y-auto flex-1 scrollbar-thin">

                <div className="w-full h-[400px]">
                    <MapSection pickupLocation={pickupData} dropLocation={dropData} status={acceptData?.status} driverLocation={driverLocation} stopList={stopList} />
                </div>

                <div className="w-full h-[5px] bg-gray-200"></div>

                <div className="px-4 py-3 flex items-center justify-between">

                    <div>
                        <h1 className="font-semibold text-[17px]">
                            {acceptData?.status
                                ? (acceptData.status === "1"
                                    ? t("Captain on the way")
                                    : acceptData.status === "2"
                                        ? t("Captain has arrived")
                                        : t("Heading to the destination"))
                                : t("Searching for Captain")}
                        </h1>
                        {acceptData?.status === "2" && (
                            <p>
                                {timeType === "Dec"
                                    ? `${t("Free wait time of")} ${acceptData?.pickuptime || 0} ${t("mins has started.")}`
                                    : t("Time's up. Extra charges apply")}
                            </p>
                        )}
                    </div>

                    {acceptData?.status ? (
                        <div
                            className={`border px-3 rounded-full ${timeType === "Dec"
                                ? "bg-[#4038ff]/10 border-[--bg-color]"
                                : "bg-green-100 border-green-600"
                                }`}
                        >
                            <span
                                className={`font-bold ${timeType === "Dec"
                                    ? "text-[--bg-color]"
                                    : "text-green-600"
                                    }`}
                            >
                                {formatTime(time)}
                            </span>
                        </div>
                    ) : (
                        <div className="border px-3 py-1 rounded-full bg-[#4038ff]/10 border-[--bg-color]">
                            <span className="font-bold text-[--bg-color] text-sm">
                                {data?.book_date} | {data?.book_time}
                            </span>
                        </div>
                    )}

                </div>

                {/* Progress Timeline */}
                <div className="px-4 py-4 border-t border-gray-100 bg-slate-50/50">
                    <div className="flex items-center justify-between relative">
                        {/* Connecting background line */}
                        <div className="absolute top-[14px] left-[5%] right-[5%] h-1 bg-gray-200 -z-0">
                            <div 
                                className="h-full bg-[--bg-color] transition-all duration-500" 
                                style={{ 
                                    width: !acceptData 
                                        ? "0%" 
                                        : acceptData.status === "1" 
                                            ? "25%" 
                                            : acceptData.status === "2" 
                                                ? "50%" 
                                                : acceptData.status === "3" || acceptData.status === "5"
                                                    ? "75%" 
                                                    : ["6", "7", "8"].includes(String(acceptData.status))
                                                        ? "100%" 
                                                        : "100%" // Cancelled / default
                                }}
                            />
                        </div>

                        {/* Step 1: Requested */}
                        <div className="flex flex-col items-center z-10 w-1/5">
                            <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold bg-[--bg-color] text-white shadow-md shadow-blue-200">
                                1
                            </div>
                            <span className="text-[10px] font-semibold mt-1 text-gray-600">{t("Requested")}</span>
                        </div>

                        {/* Step 2: Accepted */}
                        <div className="flex flex-col items-center z-10 w-1/5">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition ${
                                acceptData && Number(acceptData.status) >= 1
                                    ? "bg-[--bg-color] text-white shadow-md shadow-blue-200" 
                                    : "bg-gray-200 text-gray-400"
                            }`}>
                                2
                            </div>
                            <span className="text-[10px] font-semibold mt-1 text-gray-600">{t("Accepted")}</span>
                        </div>

                        {/* Step 3: Arrived */}
                        <div className="flex flex-col items-center z-10 w-1/5">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition ${
                                acceptData && Number(acceptData.status) >= 2
                                    ? "bg-[--bg-color] text-white shadow-md shadow-blue-200" 
                                    : "bg-gray-200 text-gray-400"
                            }`}>
                                3
                            </div>
                            <span className="text-[10px] font-semibold mt-1 text-gray-600">{t("Arrived")}</span>
                        </div>

                        {/* Step 4: Started */}
                        <div className="flex flex-col items-center z-10 w-1/5">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition ${
                                acceptData && (Number(acceptData.status) >= 3 || acceptData.status === "5")
                                    ? "bg-[--bg-color] text-white shadow-md shadow-blue-200" 
                                    : "bg-gray-200 text-gray-400"
                            }`}>
                                4
                            </div>
                            <span className="text-[10px] font-semibold mt-1 text-gray-600">{t("Ongoing")}</span>
                        </div>

                        {/* Step 5: Completed / Cancelled */}
                        <div className="flex flex-col items-center z-10 w-1/5">
                            {acceptData && acceptData.status === "4" ? (
                                <>
                                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold bg-red-500 text-white shadow-md shadow-red-200">
                                        ✕
                                    </div>
                                    <span className="text-[10px] font-semibold mt-1 text-red-500">{t("Cancelled")}</span>
                                </>
                            ) : (
                                <>
                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition ${
                                        acceptData && ["6", "7", "8"].includes(String(acceptData.status))
                                            ? "bg-green-500 text-white shadow-md shadow-green-200" 
                                            : "bg-gray-200 text-gray-400"
                                    }`}>
                                        ✓
                                    </div>
                                    <span className="text-[10px] font-semibold mt-1 text-gray-600">{t("Completed")}</span>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div className="w-full h-[5px] bg-gray-200"></div>

                {acceptData?.status && acceptData?.status <= "4" && <div className="px-4 py-2">
                    <div className="flex items-center justify-between gap-4">
                        <h1>{t("Start your order with PIN")}</h1>
                        <div className="flex gap-2">
                            {acceptData?.otp?.split("")?.map((item, index) => (
                                <span
                                    key={index}
                                    className="w-8 h-10 flex items-center justify-center border rounded-[10px] text-lg font-semibold"
                                >
                                    {item}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>}

                {acceptData?.status && acceptData?.status <= "4" && <div className="w-full h-[5px] bg-gray-200"></div>}

                {acceptData ? (
                    <div className="flex items-center justify-between gap-4 px-4 py-2">
                        <div className="flex items-center gap-4">
                            <div>
                                <button onClick={handleGetDriverDetail}>
                                    <ImageLoad src={BaseUrl + acceptData?.profile_image} CustomeStyle={"w-[50px] h-[50px] rounded-full overflow-hidden"} status={true} ImagStyle={"w-full h-full object-cover"} alt={`${acceptData?.first_name} ${acceptData?.last_name}`} />
                                </button>
                                <div className="flex items-center justify-center gap-1">
                                    <svg width="20" height="20" className="text-yellow-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                    </svg>
                                    <span>{acceptData?.rating}</span>
                                </div>
                            </div>
                            <div className="leading-5">
                                <h1 className="font-semibold text-gray-900 text-[17px]">{acceptData?.first_name} {acceptData?.last_name}</h1>
                                <span className="text-gray-600">{acceptData?.car_name}</span>
                                <p className="text-gray-600">{acceptData?.vehicle_number}</p>
                                <p className="text-xs text-[--bg-color] font-medium mt-1">
                                    {acceptData?.tot_review} reviews • {acceptData?.tot_complete_order || 0} completed rides
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={() => navigate("/chat", { state: { name: `${acceptData?.first_name} ${acceptData?.last_name}`, id: acceptData?.d_id, img: acceptData?.profile_image } })}
                            className="text-[--bg-color] hover:text-[--bg-color-hover]">
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 3H6C4 3 3 4 3 6V21L6 18H18C20 18 21 17 21 15V6C21 4 20 3 18 3ZM13 13.25H8C7.586 13.25 7.25 12.914 7.25 12.5C7.25 12.086 7.586 11.75 8 11.75H13C13.414 11.75 13.75 12.086 13.75 12.5C13.75 12.914 13.414 13.25 13 13.25ZM16 9.25H8C7.586 9.25 7.25 8.914 7.25 8.5C7.25 8.086 7.586 7.75 8 7.75H16C16.414 7.75 16.75 8.086 16.75 8.5C16.75 8.914 16.414 9.25 16 9.25Z" fill="currentColor" />
                            </svg>
                        </button>
                    </div>
                ) : (
                    <div className="px-4 py-3 bg-blue-50 border border-blue-150 rounded-lg mx-4 my-2 text-center text-sm text-blue-700 font-medium">
                        {t("Booking is scheduled. A captain will be assigned closer to your pick-up time.")}
                    </div>
                )}

                <div className="w-full h-[5px] bg-gray-200"></div>

                <div className="px-4 py-2 space-y-2">
                    {routeStops.map((stop, idx) => (
                        <div key={idx} className="flex gap-3">
                            <div className="flex flex-col items-center pt-1.5 w-5 flex-shrink-0 relative">
                                <div className={stop.colorClass}></div>
                                {idx !== routeStops.length - 1 && (
                                    <div className="absolute w-0.5 border-l-2 border-dashed border-gray-400 z-0" style={{ top: "16px", bottom: "-24px" }}></div>
                                )}
                            </div>
                            <div className="flex-1 pb-1">
                                <h1 className={`text-[11px] font-bold leading-none ${stop.textClass}`}>{stop.label}</h1>
                                <p className="text-[14px] font-medium text-gray-800 line-clamp-1 mt-1">
                                    {stop.title}
                                </p>
                                {stop.subtitle && (
                                    <p className="text-[13px] text-gray-500 line-clamp-2 mt-0.5">{stop.subtitle}</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="w-full h-[5px] bg-gray-200"></div>

                <div className="px-4 py-2">
                    <div className="flex items-center justify-between">
                        <span>{t("Total Fare")}</span>
                        <span>{currency + (acceptData?.price || data?.price)}</span>
                    </div>
                    <div className="flex items-center justify-between border-b border-gray-150 pb-2">
                        <span>{t("Paying Via")}</span>
                        <span>{data?.p_name}</span>
                    </div>
                </div>

                {detailLoading && (
                    <div className="px-4 py-3 flex items-center justify-center text-xs text-gray-500">
                        <span className="animate-spin border-2 border-t-transparent border-[--bg-color] rounded-full w-4 h-4 mr-2"></span>
                        {t("Loading additional details...")}
                    </div>
                )}

                {additionalDetail && (
                    <div className="px-4 py-3 border-t border-gray-100 bg-gray-50/50">
                        <h2 className="text-xs font-bold text-gray-800 uppercase tracking-wider mb-3">
                            {t("Additional Details")}
                        </h2>
                        
                        <div className="flex items-center gap-2 mb-3">
                            {String(additionalDetail.m_role) === "2" && (
                                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 border border-emerald-200">
                                    🌍 {t("Outstation Trip")}
                                </span>
                            )}
                            {String(additionalDetail.m_role) === "3" && (
                                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-200">
                                    ⏱️ {t("Hourly Rental")}
                                </span>
                            )}
                            {String(additionalDetail.m_role) === "4" && (
                                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-pink-100 text-pink-800 border border-pink-200">
                                    📦 {t("Package Delivery")}
                                </span>
                            )}
                        </div>

                        <div className="grid grid-cols-2 gap-3 mb-3 bg-white p-3 rounded-xl border border-gray-100 shadow-sm">
                            <div>
                                <span className="text-[10px] text-gray-400 uppercase font-semibold">{t("Book Date")}</span>
                                <p className="text-sm font-bold text-gray-800">{additionalDetail.book_date || "-"}</p>
                            </div>
                            <div>
                                <span className="text-[10px] text-gray-400 uppercase font-semibold">{t("Book Time")}</span>
                                <p className="text-sm font-bold text-gray-800">{additionalDetail.book_time || "-"}</p>
                            </div>
                        </div>

                        {String(additionalDetail.m_role) === "2" && (
                            <div className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-100 shadow-sm text-sm">
                                <span className="text-gray-500 font-medium">👥 {t("Number Of Passengers")}</span>
                                <span className="font-bold text-gray-800">{additionalDetail.num_passenger || 0}</span>
                            </div>
                        )}

                        {String(additionalDetail.m_role) === "3" && (
                            <div className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-100 shadow-sm text-sm">
                                <span className="text-gray-500 font-medium">⏱️ {t("Rental Hours")}</span>
                                <span className="font-bold text-gray-800">{additionalDetail.rent_hour || 0} {t("Hours")}</span>
                            </div>
                        )}

                        {String(additionalDetail.m_role) === "4" && (
                            <div className="space-y-3">
                                <div className="p-3 bg-white rounded-xl border border-gray-100 shadow-sm space-y-2.5">
                                    {additionalDetail.tot_kg > 0 && (
                                        <div className="flex justify-between items-center text-sm border-b border-gray-50 pb-2">
                                            <span className="text-gray-500 font-medium">⚖️ {t("Weight Limit")}</span>
                                            <span className="font-bold text-gray-800">{additionalDetail.tot_kg} kg</span>
                                        </div>
                                    )}
                                    {additionalDetail.package_details && additionalDetail.package_details.length > 0 && (
                                        <div className="grid grid-cols-3 gap-2 pt-1 text-center">
                                            <div className="bg-gray-50 p-2 rounded-lg">
                                                <span className="text-[10px] text-gray-400 font-medium block">{t("Weight")}</span>
                                                <span className="text-xs font-bold text-gray-700">{additionalDetail.package_details[0].weight} kg</span>
                                            </div>
                                            <div className="bg-gray-50 p-2 rounded-lg">
                                                <span className="text-[10px] text-gray-400 font-medium block">{t("Length")}</span>
                                                <span className="text-xs font-bold text-gray-700">{additionalDetail.package_details[0].length} cm</span>
                                            </div>
                                            <div className="bg-gray-50 p-2 rounded-lg">
                                                <span className="text-[10px] text-gray-400 font-medium block">{t("Height")}</span>
                                                <span className="text-xs font-bold text-gray-700">{additionalDetail.package_details[0].height} cm</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {additionalDetail.package_details && additionalDetail.package_details.length > 0 && (
                                    <div className="p-3 bg-white rounded-xl border border-gray-100 shadow-sm space-y-2">
                                        <h3 className="text-xs font-bold text-gray-400 uppercase mb-1">{t("Contacts")}</h3>
                                        <div className="flex justify-between items-center text-sm">
                                            <span className="text-gray-500 font-medium">📤 {t("Sender")}</span>
                                            <a href={`tel:${additionalDetail.package_details[0].sender_number}`} className="font-bold text-blue-600 hover:underline">
                                                {additionalDetail.package_details[0].sender_number} 📞
                                            </a>
                                        </div>
                                        <div className="flex justify-between items-center text-sm border-t border-gray-50 pt-2">
                                            <span className="text-gray-500 font-medium">📥 {t("Receiver")}</span>
                                            <a href={`tel:${additionalDetail.package_details[0].reciver_number}`} className="font-bold text-green-600 hover:underline">
                                                {additionalDetail.package_details[0].reciver_number} 📞
                                            </a>
                                        </div>
                                    </div>
                                )}

                                {additionalDetail.package_details && additionalDetail.package_details.length > 0 && additionalDetail.package_details[0].what_a_driver && (
                                    <div className="p-3 bg-blue-50 border border-blue-100 rounded-xl text-xs text-blue-800 leading-relaxed font-medium">
                                        <span className="font-bold block text-[10px] text-blue-600 uppercase tracking-wide mb-1">📝 {t("Driver Note")}</span>
                                        {additionalDetail.package_details[0].what_a_driver}
                                    </div>
                                )}

                                {additionalDetail.package_details && additionalDetail.package_details.length > 0 && additionalDetail.package_details[0].parcel && additionalDetail.package_details[0].parcel.length > 0 && (
                                    <div className="space-y-1.5">
                                        <span className="text-xs font-bold text-gray-400 uppercase block mb-1">{t("Parcel Images")}</span>
                                        <div className="flex gap-2.5 overflow-x-auto pb-2 scrollbar-thin">
                                            {additionalDetail.package_details[0].parcel.map((img, idx) => (
                                                <a key={idx} href={BaseUrl + img} target="_blank" rel="noopener noreferrer" className="relative flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden border border-gray-100 hover:opacity-90 transition shadow-sm">
                                                    <img src={BaseUrl + img} alt={`parcel-${idx}`} className="w-full h-full object-cover" />
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}

                <div className="px-4 py-2 border-t border-gray-50 bg-white">
                    {(!acceptData || acceptData.status <= "4") && <button onClick={() => setShowModel("Cancel")} className="w-full h-10 bg-[--bg-color] text-white font-bold italic rounded-[10px] hover:bg-[--bg-color-hover] transition-colors">
                        {t("Cancel Ride")}
                    </button>}
                </div>

                </div>
            </div>}

            {isPayment && <div className="px-5 py-3">

                <div className="flex items-center justify-between mb-2">
                    <h1 className="font-semibold text-[18px]">{t("Payment Details")}</h1>
                    <button onClick={() => setShowModel("")}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                        </svg>
                    </button>
                </div>

                <div className="mb-3">
                    {paymentData?.addi_time !== 0 && <div className="flex items-center justify-between gap-4">
                        <span>{t("Additional time")} ({paymentData?.addi_time} {t("minit")})</span>
                        <span>{currency + Number(paymentData?.addi_time_price || 0).toFixed(2)}</span>
                    </div>}
                    <div className="flex items-center justify-between">
                        <h1>{t("Platform Fee")} :</h1>
                        <span>{currency + Number(paymentData?.platform_fee || 0).toFixed(2)}</span>
                    </div>
                    <div className="flex items-center justify-between">
                        <h1>{t("Km Charge")} :</h1>
                        <span>{currency + Number(paymentData?.km_charge || 0).toFixed(2)}</span>
                    </div>
                    {(paymentData?.price || paymentData?.price !== 0) && <div className="flex items-center justify-between">
                        <h1>{t("Base Fare")} :</h1>
                        <span>{currency + Number(paymentData?.price || paymentData?.tot_price || 0).toFixed(2)}</span>
                    </div>}
                    {paymentData?.bid_addjust_amount && <div className="flex items-center justify-between">
                        <h1>{t("Bid amount")} :</h1>
                        <span>{currency + paymentData?.bid_addjust_amount}</span>
                    </div>}
                    <div className="flex items-center justify-between">
                        <h1>{t("Extra Charge")} :</h1>
                        <span>{currency + Number(paymentData?.extra_charge || 0).toFixed(2)}</span>
                    </div>
                    <div className="flex items-center justify-between font-semibold text-[17px]">
                        <h1>{t("Total Fare")} :</h1>
                        <span>{currency + Number(paymentData?.final_price || 0).toFixed(2)}</span>
                    </div>

                </div>

                <h1 className="font-semibold text-[18px] mb-2">{t("Select Payment Method")}</h1>

                <Payment Amount={paymentData?.final_price} paymentList={paymentList} bankData={bankData} selectPayment={selectPayment} setSelectPayment={setSelectPayment} setIsModel={null} index={3} Data={completeData} />
            </div>}

            {showSosModal && (
                <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl animate-fade-in text-black font-sans text-start">
                        <div className="flex justify-between items-center mb-4 border-b pb-2">
                            <h3 className="text-lg font-bold text-red-600 flex items-center gap-2">
                                <span>🚨</span> {t("ZippyGo Safety & SOS Help")}
                            </h3>
                            <button onClick={() => setShowSosModal(false)} className="text-gray-400 hover:text-gray-600 text-xl font-bold">
                                &times;
                            </button>
                        </div>

                        <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1">
                            {/* Trigger SOS */}
                            <div 
                                onClick={confirmSosTrigger} 
                                className="flex items-center gap-3 p-3 bg-red-50 hover:bg-red-100 border border-red-200 rounded-xl cursor-pointer transition-colors"
                            >
                                <div className="w-10 h-10 bg-red-600 text-white rounded-full flex items-center justify-center shrink-0">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 text-sm">{t("Trigger Emergency Alarm")}</h4>
                                    <p className="text-xs text-gray-500">{t("Notify support center & broadcast live position")}</p>
                                </div>
                            </div>

                            {/* Call Police/Emergency */}
                            <a 
                                href={`tel:${emergencyContactNumber}`}
                                className="flex items-center gap-3 p-3 bg-orange-50 hover:bg-orange-100 border border-orange-200 rounded-xl cursor-pointer transition-colors decoration-none"
                            >
                                <div className="w-10 h-10 bg-orange-500 text-white rounded-full flex items-center justify-center shrink-0">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 text-sm">{t("Call Emergency Services")} ({emergencyContactNumber})</h4>
                                    <p className="text-xs text-gray-500">{t("Direct voice call to local emergency dispatcher")}</p>
                                </div>
                            </a>

                            {/* Trusted Emergency Contacts */}
                            {emergencyContacts.map((contact) => (
                                <a 
                                    key={contact.id}
                                    href={`tel:${contact.phone}`}
                                    className="flex items-center gap-3 p-3 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-xl cursor-pointer transition-colors decoration-none"
                                >
                                    <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center shrink-0">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900 text-sm">{t("Call")} {contact.name}</h4>
                                        <p className="text-xs text-gray-500">{t("Trusted Contact")} • {contact.phone}</p>
                                    </div>
                                </a>
                            ))}

                            {/* Share Trip Link */}
                            <div 
                                onClick={() => {
                                    handleCallApi("Post", "customer/generate_tracking_link", { request_id: data?.id }).then((res) => {
                                        if (res.data && res.data.Result === true) {
                                            const url = res.data.tracking_url;
                                            navigator.clipboard.writeText(url).then(() => {
                                                setToastMsg(t("Trip tracking link copied to clipboard!"));
                                                setShowToast(true);
                                            });
                                        } else {
                                            setToastMsg(res.data.message || t("Failed to generate tracking link"));
                                            setShowToast(true);
                                        }
                                    }).catch(err => {
                                        console.error(err);
                                        setToastMsg(t("Error generating tracking link"));
                                        setShowToast(true);
                                    });
                                }} 
                                className="flex items-center gap-3 p-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-xl cursor-pointer transition-colors"
                            >
                                <div className="w-10 h-10 bg-gray-500 text-white rounded-full flex items-center justify-center shrink-0">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 10.742l4.757-2.378a3 3 0 11.83 1.666l-4.757 2.379a3 3 0 11-.83-1.666zM15 7a1 1 0 100-2 1 1 0 000 2zm0 12a1 1 0 100-2 1 1 0 000 2zM6 13a1 1 0 100-2 1 1 0 000 2z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 text-sm">{t("Share Live Trip Link")}</h4>
                                    <p className="text-xs text-gray-500">{t("Copy live tracking URL to share position")}</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 flex justify-end">
                            <button onClick={() => setShowSosModal(false)} className="px-4 py-2 border border-gray-300 text-gray-700 text-sm font-semibold rounded-xl hover:bg-gray-50 transition-colors">
                                {t("Close")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default UpcomingModel;

const getVehicleSize = (imageUrl) => {
    const height = 55; // Standard professional height on the map
    let ratio = 0.62; // Default aspect ratio (width / height)
    
    if (imageUrl) {
        const urlLower = imageUrl.toLowerCase();
        if (urlLower.includes('download1') || urlLower.includes('motorbike')) {
            ratio = 0.575;
        } else if (urlLower.includes('auto-rickshaw') || urlLower.includes('riksha')) {
            ratio = 0.639;
        } else if (urlLower.includes('group1000004645') || urlLower.includes('taxi')) {
            ratio = 0.618;
        } else if (urlLower.includes('group1000004644') || urlLower.includes('hoverboard') || urlLower.includes('hovrbord')) {
            ratio = 0.788;
        } else if (urlLower.includes('group1000004647') || urlLower.includes('group1000004646') || urlLower.includes('sedan') || urlLower.includes('car.png') || urlLower.includes('cars')) {
            ratio = 0.667;
        } else if (urlLower.includes('jeep')) {
            ratio = 0.567;
        } else if (urlLower.includes('shipping-truck')) {
            ratio = 0.558;
        } else if (urlLower.includes('van.png')) {
            ratio = 0.565;
        } else if (urlLower.includes('truck.png')) {
            ratio = 0.482;
        }
    }
    const width = Math.round(height * ratio);
    return new window.google.maps.Size(width, height);
};

const silverMapStyle = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f1f1f1"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#5f6368"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "administrative.locality",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#B2BEB5"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#B2BEB5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e0e0e0"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#6b9a76"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#dcdcdc"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9ca5b3"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e1e1e1"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#b3b3b3"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#7d7d7d"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f2f2f2"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#B2BEB5"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c8d3d6"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#5b6b74"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  }
];

const MapSection = memo(({ pickupLocation, dropLocation, status, driverLocation, stopList }) => {

    const [map, setMap] = useState(null);
    const [coords, setCoords] = useState(null);

    const driverMarkerRef = useRef(null);
    const renderersRef = useRef([]);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: secureLocalStorage.getItem("mapkey"),
    });

    const ShowPickupMarker = !status || Number(status) < 5;
    const ShowDropMarker = true;
    const ShowStopListMarker = true;

    useEffect(() => {
        if (!navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition((position) => {
            setCoords({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            });
        });
    }, []);

    useEffect(() => {
        if (driverLocation && driverMarkerRef.current) {
            animateMarker({
                lat: Number(driverLocation.lat),
                lng: Number(driverLocation.lng),
            });
        }
    }, [driverLocation]);

    useEffect(() => {
        if (!map) return;

        if (pickupLocation && dropLocation) {
            const bounds = new window.google.maps.LatLngBounds();

            bounds.extend({
                lat: Number(pickupLocation.lat),
                lng: Number(pickupLocation.lng),
            });

            bounds.extend({
                lat: Number(dropLocation.lat),
                lng: Number(dropLocation.lng),
            });

            stopList.forEach((stop) => {
                if (stop) {
                    bounds.extend({
                        lat: Number(stop.lat),
                        lng: Number(stop.lng),
                    });
                }
            });

            map.fitBounds(bounds);
            return;
        }

        if (status === "1" && pickupLocation) {
            map.panTo(pickupLocation);
            return;
        }

        if (stopList?.length > 0) {
            map.panTo(stopList[stopList.length - 1]);
            return;
        }

        if (dropLocation) {
            map.panTo(dropLocation);
            return;
        }

        if (pickupLocation) {
            map.panTo(pickupLocation);
            return;
        }

        if (coords) {
            map.panTo(coords);
        }

    }, [map, pickupLocation, dropLocation, stopList, coords, status]);

    const routePoints = useMemo(() => {
        const points = [];
        const isStarted = status && Number(status) >= 5;

        if (isStarted) {
            if (driverLocation && !isNaN(driverLocation.lat) && !isNaN(driverLocation.lng)) {
                points.push({
                    lat: Number(driverLocation.lat),
                    lng: Number(driverLocation.lng),
                });
            } else if (pickupLocation && !isNaN(pickupLocation.lat) && !isNaN(pickupLocation.lng)) {
                points.push({
                    lat: Number(pickupLocation.lat),
                    lng: Number(pickupLocation.lng),
                });
            }

            stopList?.forEach((stop) => {
                if (stop && !isNaN(stop.lat) && !isNaN(stop.lng)) {
                    points.push({
                        lat: Number(stop.lat),
                        lng: Number(stop.lng),
                    });
                }
            });

            if (dropLocation && !isNaN(dropLocation.lat) && !isNaN(dropLocation.lng)) {
                points.push({
                    lat: Number(dropLocation.lat),
                    lng: Number(dropLocation.lng),
                });
            }
        } else {
            // Pre-trip: route is from driver location to pickup location
            if (driverLocation && !isNaN(driverLocation.lat) && !isNaN(driverLocation.lng)) {
                points.push({
                    lat: Number(driverLocation.lat),
                    lng: Number(driverLocation.lng),
                });
                if (pickupLocation && !isNaN(pickupLocation.lat) && !isNaN(pickupLocation.lng)) {
                    points.push({
                        lat: Number(pickupLocation.lat),
                        lng: Number(pickupLocation.lng),
                    });
                }
            } else {
                // Fallback to standard full route from pickup to drop
                if (pickupLocation && !isNaN(pickupLocation.lat) && !isNaN(pickupLocation.lng)) {
                    points.push({
                        lat: Number(pickupLocation.lat),
                        lng: Number(pickupLocation.lng),
                    });
                }

                stopList?.forEach((stop) => {
                    if (stop && !isNaN(stop.lat) && !isNaN(stop.lng)) {
                        points.push({
                            lat: Number(stop.lat),
                            lng: Number(stop.lng),
                        });
                    }
                });

                if (dropLocation && !isNaN(dropLocation.lat) && !isNaN(dropLocation.lng)) {
                    points.push({
                        lat: Number(dropLocation.lat),
                        lng: Number(dropLocation.lng),
                    });
                }
            }
        }

        return points;
    }, [pickupLocation, dropLocation, stopList, driverLocation, status]);

    useEffect(() => {
        if (!map || routePoints.length < 2) return;

        clearRoutes();

        const directionsService = new window.google.maps.DirectionsService();

        for (let i = 0; i < routePoints.length - 1; i++) {

            const renderer = new window.google.maps.DirectionsRenderer({
                map,
                suppressMarkers: true,
                preserveViewport: true,
                polylineOptions: {
                    strokeColor: "#4038ff",
                    strokeWeight: 5,
                },
            });

            directionsService.route(
                {
                    origin: routePoints[i],
                    destination: routePoints[i + 1],
                    travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (result, status) => {
                    if (status === "OK") {
                        renderer.setDirections(result);
                        renderersRef.current.push(renderer);
                    }
                }
            );
        }

    }, [map, routePoints]);

    const clearRoutes = () => {
        renderersRef.current.forEach((r) => r.setMap(null));
        renderersRef.current = [];
    };

    const animateMarker = (newPos) => {
        const marker = driverMarkerRef.current;
        if (!marker) return;

        const start = marker.getPosition();
        if (!start) {
            marker.setPosition(newPos);
            return;
        }

        let i = 0;
        const steps = 10;

        const interval = setInterval(() => {
            i++;

            const lat = start.lat() + (newPos.lat - start.lat()) * (i / steps);
            const lng = start.lng() + (newPos.lng - start.lng()) * (i / steps);

            marker.setPosition({ lat, lng });

            if (i >= steps) clearInterval(interval);

        }, 50);
    };

    if (!isLoaded) {
        return <div className="w-full h-full shimmer"></div>;
    }

    const pickupSymbol = {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: "#22c55e",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 7,
    };

    const stopSymbol = {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: "#eab308",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 7,
    };

    const dropSymbol = {
        path: "M -6 -6 H 6 V 6 H -6 Z",
        fillColor: "#ef4444",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1,
    };

    return (
        <GoogleMap
            center={coords || { lat: 23.0225, lng: 72.5714 }}
            zoom={14}
            mapContainerStyle={{ width: "100%", height: "100%" }}
            onLoad={(mapInstance) => setMap(mapInstance)}
            options={{
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                styles: silverMapStyle,
            }}
        >

            {/* 📍 Pickup */}
            {ShowPickupMarker && pickupLocation && !isNaN(pickupLocation.lat) && !isNaN(pickupLocation.lng) && (
                <Marker
                    position={pickupLocation}
                    icon={pickupSymbol}
                />
            )}

            {/* 📍 Drop */}
            {ShowDropMarker && dropLocation && !isNaN(dropLocation.lat) && !isNaN(dropLocation.lng) && (
                <Marker
                    position={dropLocation}
                    icon={dropSymbol}
                />
            )}

            {/* 🚗 Driver */}
            {driverLocation && !isNaN(driverLocation.lat) && !isNaN(driverLocation.lng) && (
                <Marker
                    onLoad={(marker) => (driverMarkerRef.current = marker)}
                    position={{
                        lat: Number(driverLocation.lat),
                        lng: Number(driverLocation.lng),
                    }}
                    icon={{
                        url: driverLocation.image,
                        scaledSize: getVehicleSize(driverLocation.image),
                    }}
                />
            )}

            {/* 📍 Stops */}
            {ShowStopListMarker &&
                stopList?.map((item, index) => {
                    if (!item || isNaN(item.lat) || isNaN(item.lng)) return null;
                    return (
                        <Marker
                            key={index}
                            position={{
                                lat: Number(item.lat),
                                lng: Number(item.lng),
                            }}
                            icon={stopSymbol}
                        />
                    );
                })}

        </GoogleMap>
    );
});